import React from "react";
import Zumba1 from "../../../images/zumba1.jpg";
import Zumba2 from "../../../images/zumba2.jpg";
import Zumba3 from "../../../images/zumba3.jpg";
import Zumba4 from "../../../images/zumba4.jpg";
import Zumba5 from "../../../images/zumba5.jpg";
import Zumba6 from "../../../images/zumba6.jpg";
import EngagementCarouselPage from "../../ui/EngagementCarouselPage";

const Zumba = () => (
  <EngagementCarouselPage
    title="Zumba Session for Wheelchair bound"
    paragraphs={[
      "Along with the members of the Nina foundation for spinal cord injuries, we conducted a very fun and energizing zumba session, thanks to JustAllHeart. We enjoyed an evening filled with lots of dance, love and laughter!",
    ]}
    images={[Zumba1, Zumba2, Zumba3, Zumba4, Zumba5, Zumba6]}
  />
);

export default Zumba;
